<template>

  <div>
    <EditButton class="edit-button" @click="$emit('edit', item)"></EditButton>
    <DeleteButton class="delete-button" @click="$emit('delete', item)"></DeleteButton>
  </div>

</template>

<script>

import EditButton from '@/components/common/EditButton'
import DeleteButton from '@/components/common/DeleteButton'

export default {
  name: 'EditDeleteButtons',
  components: {
    EditButton,
    DeleteButton
  },
  props: ['item']
}

</script>

<style lang="scss" scoped>

.edit-button {
  height: 30px;
  vertical-align: middle;
}

.delete-button {
  height: 35px;
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/components/common/EditDeleteButtons.vue